<template>
    <div class="international_download">
        <h3>{{ $t('GreenX国际版下载') }}</h3>
        <a class="download-link" href="https://capp-build.oss-accelerate.aliyuncs.com/GreenX/GreenX_6.2.7_6020719.apk">
            <img class="iphone-logo" src="@/assets/img/安卓icon-86_86.png" alt="">
            <div class="download-text">
                <p class="download-title-h5">{{ $t('GreenX安卓版下载') }}</p>
                <p class="download-info">{{ $t('Android 下载') }}</p>
            </div>
            <img class="arrow" src="@/assets/img/箭头icon-60_60.png" alt="">
        </a>
        <p class="international-android">{{ $t('访问国际版需开启（网络加速器）才可正常使用') }}</p>
        <p class="warning">{{ $t('重要提示！！若登录状态显示USDT充值显示（暂停），请重新连接网络加速器') }}</p>
    </div>
</template>

<script lang="ts" setup>

</script>

<style scoped lang="scss">
.international_download {
    padding: 40px 15px;
}
h3 {
    font-size: 18px;
    color: black;
    text-align: center;
}
.download-link {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background-color: #1abaa2;
    color: #fff;
    -webkit-border-radius: 14px;
    -moz-border-radius: 14px;
    border-radius: 14px;
    margin-top: 30px;
    font-size: 14px;
    img {
        width: 30px;
        height: 30px;
        &.arrow {
            width: 25px;
            height: 25px;
        }
    }
}
.international-android {
    color: #747c94;
    margin-top: 30px;
    font-size: 12px;
}
.warning {
    font-size: 12px;
}
</style>